package com.klantenstop.web.pages.admin

import com.klantenstop.web.data.models.domain.ModerationEntry
import com.klantenstop.web.utils.MVI

interface AdminHomeContract : MVI<AdminHomeContract.State, AdminHomeContract.Intent, AdminHomeContract.Effect> {

    data class State(
        val companyItems: List<ModerationEntry> = emptyList(),
        val statusItems: List<ModerationEntry> = emptyList(),
        val reviewItems: List<ModerationEntry> = emptyList(),
        val companyTotal: Long = 0,
        val statusTotal: Long = 0,
        val reviewTotal: Long = 0,
        val isLoadingCompanies: Boolean = false,
        val isLoadingStatuses: Boolean = false,
        val isLoadingReviews: Boolean = false,
        val companyError: String? = null,
        val statusError: String? = null,
        val reviewError: String? = null,
    )

    sealed class Intent {
        data object LoadModerationQueues : Intent()
    }

    sealed class Effect {
        data class ShowError(val message: String) : Effect()
    }
}
